import React from 'react';
import VMasker from 'vanilla-masker';
import { FaBan, FaCheck } from 'react-icons/fa';
import {
  FormGroup,
  Label,
  ToggleInputContainer,
  ToggleInputField,
  ToggleButton,
  ErrorMessage,
} from '../../styles';

interface MoneyInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  required?: boolean;
  error?: string;
  disabled?: boolean;
  // Toggle functionality
  toggleable?: boolean;
  isEnabled?: boolean;
  onToggle?: (enabled: boolean) => void;
}

const MoneyInput: React.FC<MoneyInputProps> = ({
  label,
  value,
  onChange,
  placeholder = 'R$ 0,00',
  required,
  error,
  disabled,
  toggleable = false,
  isEnabled = true,
  onToggle,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value;
    const maskedValue = VMasker.toMoney(rawValue, {
      precision: 2,
      separator: ',',
      delimiter: '.',
      unit: 'R$ ',
    });
    onChange(maskedValue);
  };

  const handleToggle = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (onToggle) {
      const newEnabled = !isEnabled;
      onToggle(newEnabled);
      if (!newEnabled) {
        // When disabling, clear the value
        onChange('R$ 0,00');
      }
    }
  };

  const isFieldDisabled = disabled || (toggleable && !isEnabled);

  return (
    <FormGroup>
      <Label required={required && isEnabled}>{label}</Label>
      <ToggleInputContainer disabled={isFieldDisabled}>
        <ToggleInputField
          type="text"
          value={isFieldDisabled ? 'R$ 0,00' : value}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={isFieldDisabled}
          inputMode="decimal"
        />
        {toggleable && (
          <ToggleButton
            type="button"
            enabled={isEnabled}
            onClick={handleToggle}
          >
            {isEnabled ? <FaCheck size={16} /> : <FaBan size={16} />}
          </ToggleButton>
        )}
      </ToggleInputContainer>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </FormGroup>
  );
};

export default MoneyInput;
